module.exports = __webpack_public_path__ + "img/7.08173d3b.jpg";